// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bff7fa3/js/" + chunkId + ".js";
};